import { render, staticRenderFns } from "./CourseText.vue?vue&type=template&id=fae0ead0&"
import script from "./CourseText.vue?vue&type=script&lang=js&"
export * from "./CourseText.vue?vue&type=script&lang=js&"
import style0 from "./CourseText.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports